import React from 'react';
import { PlusIcon } from '../../../../../../../../components/icons/PlusIcon';

type AddPerUnitUsageChargeVariantProps = {
  onAddVariant: () => void;
};

export const AddPerUnitUsageChargeVariant: React.FC<AddPerUnitUsageChargeVariantProps> = ({ onAddVariant }) => {
  return (
    <button
      type="button"
      className="text-icon enabled:text-style group flex items-center space-x-1 disabled:cursor-default"
      onClick={onAddVariant}
    >
      <PlusIcon className="text-icon group-hover:text-style h-6 w-6"/>
      <label className="cursor-pointer text-sm group-disabled:cursor-default">
        Add Product Variant
      </label>
    </button>
  );
};